export default __webpack_public_path__ + "static/media/delivered-icon.9e38ab5c.svg";